import { render } from "./UnifiedQAQCDashboard.vue?vue&type=template&id=4f8d6a1a"
import script from "./UnifiedQAQCDashboard.vue?vue&type=script&lang=js"
export * from "./UnifiedQAQCDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__